// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-layers-ContextMenu-module__contextMenu {
    background-color: white;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    padding: 0.5em 0;
    border-radius: 3px 3px 3px 3px;
}
`, "",{"version":3,"sources":["webpack://./src/layers/ContextMenu.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,wCAAwC;IACxC,gBAAgB;IAChB,8BAA8B;AAClC","sourcesContent":[".contextMenu {\n    background-color: white;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);\n    padding: 0.5em 0;\n    border-radius: 3px 3px 3px 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contextMenu": `src-layers-ContextMenu-module__contextMenu`
};
export default ___CSS_LOADER_EXPORT___;
